// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__3_m3H","spinnerCircle":"Spinner_spinnerCircle__G-HEf","spin":"Spinner_spin__2NPaS"};